// Thin seam over full-page navigation. jsdom's window.location is non-configurable and cannot be
// mocked or spied on, so code that hard-navigates must route through here for tests to assert the
// destination (see Sidebar.test.tsx for the prior art on this limitation).

/** Full-page navigation that keeps the current entry in history. */
export function hardNavigate(url: string): void {
  window.location.href = url;
}

/** Full-page navigation that replaces the current history entry. */
export function hardReplace(url: string): void {
  window.location.replace(url);
}

/** Full-page reload of the current URL (same entry, fresh HTML and assets). */
export function hardReload(): void {
  window.location.reload();
}
